import { useDebouncedValue } from '@mantine/hooks';
import * as Mui from '@material-ui/core';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InlineMultiSelect } from '../../../../../components/form/inline-multiselect';
import { ConfirmationPopover } from '../../../../../components/form/warning-popover';
import Search from '../../../../../components/search';
import { IconTrash } from '../../../../../components/svg';
import { useTheme } from '../../../../../ThemeContext';
import { CreateCategoryDrawer } from './create-category-drawer';
import { ManageCatelogProducts } from './manage-catalog-products';
import { SubcategoriesDrawer } from './subcategories-drawer';
import { getOrgwiseProducts } from '../../../../../reduxs/actions';
import { useTranslation } from 'react-i18next';


const getBorderColor = (theme) => {
    return theme === 'dark' ? '#37395B' : '#E9ECEF';
}

export const ManageCatelog = ({ formikProps }) => {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState('');

    const [debouncedSearchQuery] = useDebouncedValue(searchQuery, 200);

    const [openCreateCategoryDrawer, setOpenCreateCategoryDrawer] = useState(false);
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);


    const setCategoryToEdit = (categoryId) => {
        setSelectedSubCategoryId(categoryId)
    }


    const borderColor = getBorderColor(theme);


    const { organizations, orgwiseProducts } = useSelector(state => state.organization);
    const organizationList = organizations?.filter(organization => organization?.statusConfigChoice?.configChoice === 'active').map(organization => ({
        label: organization.name,
        value: organization.uuid
    }));


    const applyOrganizations = () => {
        formikProps.setFieldValue('organizations', formikProps.values.currOrganizations)
        const newOrg = checkIfOrgAlreadySelected(formikProps.values.currOrganizations);
        checkCategoryProducts(formikProps.values.currOrganizations);
        if (newOrg.length > 0) {
            dispatch(getOrgwiseProducts({ orgUUIDs: newOrg }));
        }
    }


    const checkIfOrgAlreadySelected = (organizations) => {
        if (!orgwiseProducts) return organizations;
        const currentOrg = Object.keys(orgwiseProducts);
        const newOrg = organizations.filter(org => !currentOrg.includes(org));

        return newOrg;
    }


    const checkCategoryProducts = (organizations) => {
        const updatedCategories = formikProps?.values?.categories?.map((category) => {
            return {
                ...category,
                subCategories: category.subCategories.map((subCategory) => {
                    return {
                        ...subCategory,
                        products: subCategory.products.filter((product) => organizations.includes(product.orgId))
                    }
                })
            }
        })
        formikProps.setFieldValue('categories', [...updatedCategories])
    }

    // const isOrgError = formikProps.touched.currOrganizations === true && formikProps.errors.currOrganizations;

    const isOrgChanged = formikProps.values.currOrganizations.length !== formikProps.values.organizations.length ||
        formikProps.values.currOrganizations.some(org => !formikProps.values.organizations.includes(org));


    return <>
        <Mui.Box className="mb-1 pb-1" style={{ border: `1px solid ${borderColor}`, padding: '2rem 2rem 0rem 2rem', borderRadius: '1rem' }}>
            <Mui.Box>
                <Mui.Typography
                    component="h5"
                    variant="h5"
                    className="mb-1 font-weight-medium"
                >
                    {t("ORGANIZATION.ONBOARD.CATALOG.ORG_PRODUCTS_TITLE")}
                </Mui.Typography>
                <Mui.Typography
                    component="h6"
                    variant="h6"
                    className="mb-3 font-weight-normal text-color-grey"
                >
                    {t("ORGANIZATION.ONBOARD.CATALOG.ORG_PRODUCTS_DESC")}
                </Mui.Typography>
            </Mui.Box>
            <Mui.Grid container spacing={1} alignItems={'flex-end'}>
                <Mui.Grid item xs={10} md={8} >
                    <InlineMultiSelect
                        name="buildings"
                        label={t("ORGANIZATION.ONBOARD.CATALOG.SELECT_ORGS")}
                        data={organizationList || []}
                        value={formikProps.values.currOrganizations}
                        onChange={(value) => {
                            formikProps.setFieldValue("currOrganizations", value);
                        }}
                        // onBlur={() => {
                        //     if (!isOrgError) {
                        //         formikProps.setFieldTouched("currOrganizations", true);
                        //     }
                        // }}
                        clearable
                        searchable
                        nothingFound={t("ORGANIZATION.ONBOARD.CATALOG.NO_ORGS")}
                        // error={isOrgError ? formikProps.errors.currOrganizations : undefined}
                        description={!!orgwiseProducts ? t("ORGANIZATION.ONBOARD.CATALOG.ORG_REMOVE_NOTE") : ''}
                    />
                </Mui.Grid>
            </Mui.Grid>

            <Mui.Button
                size="small"
                disableElevation
                onClick={() => {
                    // if (!isOrgError && formikProps.values.currOrganizations.length > 0) {
                    applyOrganizations()
                    // } else {
                    //     checkCategoryProducts(formikProps.values.currOrganizations)
                    //     formikProps.setFieldValue('organizations', formikProps.values.currOrganizations)
                    //     formikProps.setFieldTouched("currOrganizations", true);
                    // }
                }}
                className="btn-small no-color-btn mt-1"
                style={{ fontSize: '1.4rem' }}
            >
                {t("ORGANIZATION.ONBOARD.CATALOG.APPLY")}
                {/* <span className="ml-1 line-height-null">
                    <IconTrash />
                </span> */}
            </Mui.Button>
        </Mui.Box>
        <Mui.Box style={{ border: `1px solid ${borderColor}`, padding: '2rem 2rem 0rem 2rem', borderRadius: '1rem', position: 'relative' }}>
            {isOrgChanged && <Mui.Box style={{
                position: 'absolute',
                top: 0, right: 0,
                zIndex: 1, borderRadius: '1rem',
                height: '100%', width: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                backdropFilter: 'blur(2px)',

            }} />}
            <Mui.Box className='d-flex justify-content-between align-items-center'>
                <Mui.Box>
                    <Mui.Typography
                        component="h5"
                        variant="h5"
                        className="mb-1 font-weight-medium"
                    >
                        {t("ORGANIZATION.ONBOARD.CATALOG.MASTER_TITLE")}
                    </Mui.Typography>
                    <Mui.Typography
                        component="h6"
                        variant="h6"
                        className="font-weight-normal text-color-grey"
                    >
                        {t("ORGANIZATION.ONBOARD.CATALOG.MASTER_DESC")}
                    </Mui.Typography>
                </Mui.Box>
                <Mui.Box style={{ width: '30%' }}>
                    <Search
                        placeholder={t("ORGANIZATION.ONBOARD.CATALOG.SEARCH_CATEGORY")}
                        value={searchQuery}
                        onSearch={(e) => setSearchQuery(e.target.value)}
                        enableClear={true}
                    />
                </Mui.Box>
            </Mui.Box>
            <Mui.Box className='mt-3 d-flex' style={{ height: '90vh', borderTop: `2px solid ${borderColor}` }}>
                <Mui.Box style={{ flex: 2, borderRight: `2px solid ${borderColor}` }}>
                    <ManageCatelogCategory
                        key={'manage-catelog-category'}
                        setOpenCreateCategoryDrawer={setOpenCreateCategoryDrawer}
                        setCategoryToEdit={setCategoryToEdit}
                        formikProps={formikProps}
                    />
                </Mui.Box>
                <Mui.Box style={{ flex: 5, height: '100%', minHeight: 0 }}>
                    <ManageCatelogProducts
                        key={'manage-catelog-products'}
                        formikProps={formikProps}
                        searchQuery={debouncedSearchQuery}
                    />
                </Mui.Box>
            </Mui.Box>
            <CreateCategoryDrawer
                open={openCreateCategoryDrawer}
                onClose={() => setOpenCreateCategoryDrawer(false)}
                formikProps={formikProps}
            />

            <SubcategoriesDrawer
                open={!!selectedSubCategoryId}
                onClose={() => setSelectedSubCategoryId(null)}
                formikProps={formikProps}
                selectedSubCategoryId={selectedSubCategoryId}
            />
        </Mui.Box>
    </>
}

// Left Section
const ManageCatelogCategory = ({ setOpenCreateCategoryDrawer, setCategoryToEdit, formikProps }) => {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const { categories, selectedSubCategory } = formikProps.values;

    const borderColor = getBorderColor(theme);


    const removeSubCategory = (parentCategoryId, subCategoryId) => {

        const updatedCategories = categories.map((category) => {

            if (category.parentCategory.id === parentCategoryId
                && category.subCategories.find((subCategory) => subCategory.id === subCategoryId)) {

                const updatedSubCategories = category.subCategories.filter((subCategory) => subCategory.id !== subCategoryId)
                if (updatedSubCategories.length === 0) {
                    return null
                }
                return {
                    ...category,
                    subCategories: category.subCategories.filter((subCategory) => subCategory.id !== subCategoryId)
                }
            }
            return category;
        }).filter((category) => category !== null)

        formikProps.setFieldValue('categories', [...updatedCategories])
        formikProps.setFieldValue('selectedSubCategory', null)
    }

    return <Mui.Box style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Mui.Box
            className='d-flex justify-content-between align-items-center pl-1 pr-1 pt-2 pb-2'
            style={{
                background: theme === 'dark' ? '#373963' : '#F8F8F8',
            }}
        >
            <Mui.Typography
                className='font-weight-medium'
                variant='h5'
            >
                {t("ORGANIZATION.ONBOARD.CATALOG.CATEGORIES")}
            </Mui.Typography>
            <Mui.Button
                className='btn-small no-color-btn'
                variant='outlined'
                color='primary'
                onClick={() => setOpenCreateCategoryDrawer(true)}
            >
                {t("ORGANIZATION.ONBOARD.CATALOG.ADD")}
            </Mui.Button>
        </Mui.Box>
        <Mui.Box className='p-1' style={{ flex: 1, overflowY: 'auto' }}>
            {categories.length <= 0
                ? <NoCategories />
                :
                categories.map((category, index) => (
                    <Mui.Box key={index} className='mb-2'>
                        <Mui.Typography onClick={() => setCategoryToEdit(category.parentCategory.id)} className='font-weight-normal text-color-primary pointer mb-1' variant='h5' component='h5' style={{ textDecoration: 'underline', fontSize: '1.6rem' }}>
                            {category.parentCategory.name}
                        </Mui.Typography>
                        <Mui.Box>
                            {category.subCategories.map((subCategory, index) => (
                                <Mui.Box
                                    key={index}
                                    className='d-flex align-items-center justify-content-between p-1 mb-1 pointer'
                                    style={{
                                        padding: '1rem 0',
                                        border: `1px solid ${selectedSubCategory?.id === subCategory?.id ? '#3121B2' : borderColor}`,
                                        borderRadius: '0.8rem',
                                    }}
                                    onClick={() => {
                                        formikProps.setFieldValue('selectedSubCategory', { ...subCategory, parentCategory: category.parentCategory })
                                    }}
                                >
                                    <Mui.Typography variant='h6' component='h6' className='font-weight-normal'>
                                        {subCategory.name}
                                    </Mui.Typography>
                                    <Mui.Box className='d-flex align-items-center' gridGap={5}>
                                        <Mui.Box className='d-flex justify-content-center align-items-center' style={{ background: theme === 'dark' ? '#37395B' : '#F8F8F8', border: '#9aa1a730 1px solid', borderRadius: '2rem', height: '3.5rem', width: '3.5rem' }}>
                                            <Mui.Typography variant='h6' component='h6' className='font-weight-normal'>
                                                {subCategory?.products?.length}
                                            </Mui.Typography>
                                        </Mui.Box>
                                        <ConfirmationPopover
                                            component={(handleClose) =>
                                                <IconTrash
                                                    width={20}
                                                    height={20}
                                                    fill={theme === 'dark' ? '#F8F8F9' : '#A4A7AE'}
                                                    className='pointer'
                                                    onClick={handleClose}
                                                />
                                            }
                                            title={t("ORGANIZATION.ONBOARD.CATALOG.DELETE_SUBCATEGORY")}
                                            description={t("ORGANIZATION.ONBOARD.CATALOG.DELETE_SUBCATEGORY_DESC")}
                                            onConfirm={() => {
                                                removeSubCategory(category?.parentCategory?.id, subCategory?.id)
                                            }}
                                        />
                                    </Mui.Box>
                                </Mui.Box>
                            ))}
                        </Mui.Box>
                    </Mui.Box>
                ))
            }
        </Mui.Box>
    </Mui.Box>

}


const NoCategories = () => {
    const { t } = useTranslation();
    return <Mui.Box className='d-flex flex-column align-items-start justify-content-center p-3' style={{ height: '100%' }}>
        <Mui.Box className="mt-2">
            <Mui.Typography style={{ textAlign: 'center' }} className='font-weight-medium' variant='h5' component={'h5'}>
                {t("ORGANIZATION.ONBOARD.CATALOG.NO_CATEGORIES")}
            </Mui.Typography>
            <Mui.Typography style={{ textAlign: 'center' }} className='font-weight-normal' variant='h6' component={'h6'}>
                {t("ORGANIZATION.ONBOARD.CATALOG.NO_CATEGORIES_DESC")}
            </Mui.Typography>
        </Mui.Box>
    </Mui.Box>
}